import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionsService } from '../../modules/besharp-sessions/lib/services/sessions.service';

export const externalRoleGuard: CanActivateFn = (_route, _state) => {
  const sessionService = inject(SessionsService);
  const router = inject(Router);
  try {
    if (!sessionService.activeSessionId) {
      router.navigate(['/session/signin']);
      return false;
    }
    const session = sessionService.getSession(sessionService.activeSessionId);
    if (session) {
      return true;
    }
    router.navigate(['/session/signin']);
    return false;
  } catch (_error) {
    router.navigate(['/session/signin']);
    return false;
  }
};

export class ExternalRoleGuardService {
  canActivate = externalRoleGuard;
}
